angular.module('memberPortal').controller('MemberLoginCtrl', ["$scope", "$state", "$stateParams", "$http", "$window", "DataService", function($scope, $state, $stateParams, $http, $window, DataService) {
  var clearMessages, domain;
  $scope.data = DataService;
  domain = $scope.data.domain;
  if (DataService.isAuthenticated) {
    $state.go('memberPortal.bookings', {
      m: $stateParams.hash
    });
  }
  clearMessages = function() {
    $scope.error = '';
    return $scope.notice = '';
  };
  $scope.getHash = function() {
    return $stateParams.hash || $stateParams.m;
  };
  $scope.login = function(pin) {
    var hash, url;
    clearMessages();
    hash = $stateParams.hash;
    url = `/websites/${domain}/members/logins/${hash}`;
    return $http.put(url, {
      pin: pin
    }).then(function() {
      url = $state.href('memberPortal.bookings', {
        m: $stateParams.hash
      });
      $window.open(url, '_self');
      return true;
    }, function() {
      return $scope.error = 'PIN incorrect or account is disabled. Please try again.';
    });
  };
  $scope.sendLoginLink = function(email) {
    var url;
    clearMessages();
    url = `/websites/${domain}/members/logins`;
    return $http.post(url, {
      email: email
    }).then(function() {
      $scope.notice = 'Login link email sent';
      return $scope.email = '';
    }, function() {
      return $scope.error = "Request could not be completed. Please try again";
    });
  };
  return $scope.sendPin = function(email = '') {
    var url;
    clearMessages();
    url = `/websites/${domain}/members/pins`;
    return $http.post(url, {
      email: email
    }).then(function() {
      $scope.notice = 'PIN email sent';
      return $scope.email = '';
    }, function() {
      return $scope.error = "Request could not be completed. Please try again.";
    });
  };
}]);
